(function () {
  var HINT_DELAY = 450;
  var AXIS_LOCK = 8;

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function isCoarsePointer() {
    try {
      return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    } catch (e) {
      return false;
    }
  }

  function initBeforeAfter(root) {
    if (root.getAttribute('data-hmc-ba-init') === 'true') return;
    root.setAttribute('data-hmc-ba-init', 'true');

    var range = root.querySelector('[data-hmc-ba-range]');
    var frame = root.querySelector('[data-hmc-ba-frame]') || root.querySelector('.hmc-ba__frame');
    if (!range || !frame) return;

    function apply(value) {
      var pos = clamp(parseFloat(value), 0, 100);
      if (isNaN(pos)) pos = 50;
      root.style.setProperty('--hmc-ba-pos', pos + '%');
      range.value = String(pos);
      root.classList.toggle('is-far-left', pos < 22);
      root.classList.toggle('is-far-right', pos > 78);
    }

    function posFromClientX(clientX) {
      var rect = frame.getBoundingClientRect();
      if (!rect.width) return parseFloat(range.value) || 50;
      return clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
    }

    function stopHint() {
      root.classList.remove('is-hinting');
    }

    range.addEventListener('input', function () {
      stopHint();
      apply(range.value);
    });

    apply(range.value);

    var drag = null;

    function endDrag(event) {
      if (!drag || (event && event.pointerId !== drag.id)) return;
      if (drag.locked === 'x' && event) apply(posFromClientX(event.clientX));
      drag = null;
      root.classList.remove('is-dragging');
      frame.style.touchAction = '';
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      stopHint();
      drag = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        /* Mouse can drag immediately; touch waits for axis lock so page scroll still works */
        locked: event.pointerType === 'mouse' ? 'x' : null,
      };
      if (drag.locked === 'x') root.classList.add('is-dragging');
      try {
        frame.setPointerCapture(event.pointerId);
      } catch (err) {}
    }

    function onPointerMove(event) {
      if (!drag || event.pointerId !== drag.id) return;

      var dx = event.clientX - drag.startX;
      var dy = event.clientY - drag.startY;

      if (!drag.locked) {
        if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          /* Vertical intent — release so the page can scroll */
          try {
            frame.releasePointerCapture(event.pointerId);
          } catch (err) {}
          drag = null;
          root.classList.remove('is-dragging');
          frame.style.touchAction = '';
          return;
        }
        drag.locked = 'x';
        root.classList.add('is-dragging');
        /* Once horizontal, stop the browser from stealing the gesture */
        frame.style.touchAction = 'none';
      }

      if (drag.locked !== 'x') return;
      if (event.cancelable) event.preventDefault();
      apply(posFromClientX(event.clientX));
    }

    frame.addEventListener('pointerdown', onPointerDown);
    frame.addEventListener('pointermove', onPointerMove, { passive: false });
    frame.addEventListener('pointerup', endDrag);
    frame.addEventListener('pointercancel', endDrag);
    frame.addEventListener('lostpointercapture', function () {
      if (!drag) return;
      drag = null;
      root.classList.remove('is-dragging');
      frame.style.touchAction = '';
    });

    var start = parseFloat(root.getAttribute('data-start')) || 50;

    /* Skip auto-hint on phones — it fought scroll and felt like the slider was jumping */
    if (prefersReducedMotion() || isCoarsePointer() || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();

          window.setTimeout(function () {
            if (root.classList.contains('is-dragging')) return;
            root.classList.add('is-hinting');
            apply(clamp(start + 14, 0, 95));

            window.setTimeout(function () {
              if (!root.classList.contains('is-hinting')) return;
              apply(start);
              window.setTimeout(function () {
                root.classList.remove('is-hinting');
              }, 950);
            }, 800);
          }, HINT_DELAY);
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-hmc-ba]').forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    scope.querySelectorAll('[data-hmc-ba]').forEach(initBeforeAfter);
  });
})();
